import {WebStorageStateStore} from "oidc-client"

declare const __VERSION__: string
declare const __TARGET_ENV__: string

export interface EnvConfig {
    TARGET_ENVIRONMENT: "PROD" | "DEV",
    API: {
        SPCI_BASE_URL: string,
    },
    OIDC_AUTHORITY: string,
    OIDC_SCOPES: string,
    OIDC_CLIENT_ID: string,
    TRACKING: {
        LOG_ROCKET_APP_ID: string,
    }
}

const isTargetingProduction = __TARGET_ENV__ === "PROD"
const appUrl: string = window.location.origin
const envConfig = ((isTargetingProduction ? require("./prod.config") : require("./dev.config")).envConfig)

export const appConfig = {
    IS_DEBUG: process.env.NODE_ENV !== "production",
    VERSION: __VERSION__,
    IS_TARGETING_PRODUCTION: isTargetingProduction,

    OIDC_SETTINGS: {
        authority: envConfig.OIDC_AUTHORITY,
        client_id: envConfig.OIDC_CLIENT_ID,
        scope: envConfig.OIDC_SCOPES,
        response_type: "code",
        userStore: new WebStorageStateStore({store: localStorage}),
        redirect_uri: `${appUrl}/auth/signin-success`,
        silent_redirect_uri: `${appUrl}/auth/silent-signin-success.html`,
        post_logout_redirect_uri: `${appUrl}/auth/signout-success`,
        automaticSilentRenew: true, // If true, oidc-client will try to renew your token when it is about to expire,
        loadUserInfo: false,
    },

    ...envConfig,
}
